module.exports = __webpack_public_path__ + "static/fonts/Fact-ExtraBoldItalic.f694e1b.eot";